import { useHttpClient } from '@/common/api/httpClient';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';

export interface InboundDeliveryTransactionResponse {
  transactionTimeUtc: Date;
  userId: string;
  productId: string;
  storageAreaId: string | null;
  weight: number | null;
  volume: number | null;
  comment: string | null;
}

export interface InboundDeliveryTransactionResult {
  ok: true;
  transactions: InboundDeliveryTransactionResponse[];
}

export function useListInboundDeliveryTransactionApi() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute(deliveryId: string) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`delivery/inbound/transaction/${deliveryId}`), {
      headers,
    });

    const title = translations.value.inboundDelivery.actions.fetchTransactions.title;
    const error = translations.value.inboundDelivery.actions.fetchTransactions.error;

    const response = await httpClient.action<InboundDeliveryTransactionResult>(request, {
      title: title,
      errorTitle: error,
      async processOk(response) {
        const transactions = (await response.json()) as InboundDeliveryTransactionResponse[];

        return {
          ok: true,
          transactions: transactions,
        };
      },
    });

    return response;
  }
}
